import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { discardProcedureContent } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function discardContent({
  accountId,
  procedureId,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    discardProcedureContent(accountId, procedureId),
    {
      method: 'PUT',
      headers: {
        Authorization: getTokenWithType(),
        'content-type': 'application/json',
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  procedureId: number;
};

type TSnapshot = unknown;

function useUndoProcedureContent(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const response = await discardContent(params);
    if (response.Data) {
      queryClient.invalidateQueries(['get_procedure', params.accountId], {
        refetchInactive: true,
      });
    } else if (response && response.Errors) throw response;
    return response;
  });
}

export { useUndoProcedureContent };
